export const BENTO_CELL_CLASSES = [
  'min-h-[220px] sm:min-h-[260px] lg:row-span-2 lg:min-h-0',
  'min-h-[200px] sm:col-span-2 lg:col-span-2 lg:min-h-0',
  'min-h-[180px] lg:min-h-0',
  'min-h-[180px] lg:min-h-0',
  'min-h-[180px] sm:col-span-2 lg:col-span-2 lg:min-h-0',
] as const;

export const TESTIMONIAL_COLORS = ['#ed1c22', '#1a6ed8', '#12a05c', '#d97706'] as const;
